import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
  Skeleton,
  Box,
} from "@mui/material";

const ReminderDialog = ({ open, onClose, reminderDetails }) => {
  if (!reminderDetails) return null;

  const isLoading = !reminderDetails;
  const status = reminderDetails.active ? "Active" : "Inactive";
  const statusColor = reminderDetails.active ? "#2e7d32" : "#d32f2f";

  const forecastTermLabel =
    reminderDetails.forecastTerm === 1
      ? "Short Term"
      : reminderDetails.forecastTerm === 2
        ? "Long Term"
        : "N/A";


  const roles =
    Array.isArray(reminderDetails.roles) && reminderDetails.roles.length > 0
      ? reminderDetails.roles.join(", ")
      : "N/A";


  const userEmails =
    Array.isArray(reminderDetails.userEmails)
      ? reminderDetails.userEmails.join(", ")
      : reminderDetails.userEmails?.trim() || "N/A";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableScrollLock
    >
      <DialogTitle>Reminder Details</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          {isLoading ? (
            [...Array(8)].map((_, index) => (
              <Stack key={index} direction="row" spacing={1}>
                <Skeleton width={150} height={24} />
                <Skeleton width="55%" height={24} />
              </Stack>
            ))
          ) : (
            <>
              <Typography>
                <strong>Data Element:</strong>{" "}
                {reminderDetails.dataElement || "N/A"}
              </Typography>

              {reminderDetails.dataElement === "Bottler Concentrate Forecast" && (
                <Typography>
                  <strong>Forecast Term:</strong> {forecastTermLabel}
                </Typography>
              )}

              <Typography>
                <strong>Reminder Period:</strong>{" "}
                {reminderDetails.reminderPeriodDisplayName ||
                  reminderDetails.reminderPeriod ||
                  "N/A"}
              </Typography>

              <Typography>
                <strong>No of Days:</strong>{" "}
                {reminderDetails.ndays ?? "N/A"}
              </Typography>


              <Typography>
                <strong>Roles:</strong> {roles}
              </Typography>


              <Typography sx={{ wordBreak: "break-word" }}>
                <strong>User Emails:</strong> {userEmails}
              </Typography>

              {reminderDetails.dataElement === "Bottler Concentrate Forecast" && (
                <Typography sx={{ wordBreak: "break-word" }}>
                  <strong>Bottler:</strong> {reminderDetails.bottler || "N/A"}
                </Typography>)}

              {reminderDetails.dataElement !== "Bottler Concentrate Forecast" && (
                <Typography sx={{ wordBreak: "break-word" }}>
                  <strong>Bottler Owner Code:</strong> {reminderDetails.bottlerOwnerCode + " (" + reminderDetails.bottler + ")" || "N/A"}
                </Typography>)}

              {reminderDetails.dataElement !== "Bottler Concentrate Forecast" && (
                <Typography sx={{ wordBreak: "break-word" }}>
                  <strong>Customer Countries:</strong>{" "}
                  {Array.isArray(reminderDetails.customerCountryList)
                    ? reminderDetails.customerCountryList.join(", ")
                    : "N/A"}
                </Typography>
              )}

              {reminderDetails.dataElement === "Bottler Concentrate Forecast" && (
                <Box>
                  <Typography>
                    <strong>Combination:</strong>
                  </Typography>

                  {reminderDetails.customerInfoList?.length > 0 ? (
                    reminderDetails.customerInfoList.map((customer, index) => (
                      <Typography key={index} sx={{ ml: 2, wordBreak: "break-word" }}>
                        <strong>{customer.customerID}</strong> - {customer.locationIds.join(", ")}
                      </Typography>
                    ))
                  ) : (
                    <Typography sx={{ ml: 2 }}>N/A</Typography>
                  )}
                </Box>
              )}

              <Typography>
                <strong>Status:</strong>
                <span
                  style={{
                    color: statusColor,
                    marginLeft: "8px",
                    fontWeight: 500,
                  }}
                >
                  {status}
                </span>
              </Typography>
            </>
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "black",
            "&:hover": { backgroundColor: "#333" },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReminderDialog;